export default 'M7 6v4a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0m4 0v4a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0m5 2A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-2 0A6 6 0 0 0 2 8a6 6 0 0 0 12 0';